import { Response } from '@marketplace-web/shared/api-client'
import { transformPaginationDto } from '@marketplace-web/domain/pagination-data'
import {
  ProductItemModel,
  transformItemBoxDto,
  transformPartialUserDtoToProductItemUser,
} from '@marketplace-web/domain/product-item-data'
import {
  getDominantColor,
  getItemThumbnail,
  ItemThumbnailSize,
  transformItemPhotoDtos,
} from '@marketplace-web/domain/item-photo-data'
import { transformCurrencyAmountDto } from 'data/transformers/currency-amount'

import { BundleItemDto, UserBundleItemsModel, UserBundleItemsResp } from '../types/bundle-items'

export const transformBundleItemDtoToProductItem = (item: BundleItemDto): ProductItemModel => ({
  id: item.id,
  title: item.title,
  url: '',
  photos: transformItemPhotoDtos(item.photos),
  favouriteCount: item.favourite_count,
  user: transformPartialUserDtoToProductItemUser({ business: item.is_owner_business }),
  priceWithDiscount: item.discount_price ? transformCurrencyAmountDto(item.discount_price) : null,
  price: transformCurrencyAmountDto(item.price),
  totalItemPrice: item.total_item_price
    ? transformCurrencyAmountDto(item.total_item_price)
    : undefined,
  thumbnailUrl: getItemThumbnail(item.photos, ItemThumbnailSize.Large),
  dominantColor: getDominantColor(item.photos),
  badge: item.badge,
  isFavourite: item.is_favourite,
  itemBox: item.item_box && transformItemBoxDto(item.item_box),
  isHeavyBulky: item.is_heavy_bulky,
})

export const transformBundleItemDtosToProductItems = (
  items: Array<BundleItemDto>,
): Array<ProductItemModel> => items.map(item => transformBundleItemDtoToProductItem(item))

export const transformUserBundleItems = (response: UserBundleItemsResp): UserBundleItemsModel => ({
  items: transformBundleItemDtosToProductItems(response.items),
  pagination: transformPaginationDto(response.pagination),
})

export const transformUserBundleItemsResponse = (response: Response<UserBundleItemsResp>) =>
  transformUserBundleItems(response)
